import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {MessengerService} from '../../messenger/messenger.service';
import {BreadcrumbsService} from '../../shared/components/breadcrumbs/breadcrumbs.service';
import {Auth, IUserToRegister} from '../auth.service';

export interface IAlert {
    id: number;
    type: string;
    message: string;
}

@Component({
    selector: 'kkk-registration',
    templateUrl: './registration.component.html',
    styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent implements OnInit, AfterViewInit {

    @ViewChild('emailField')
    private _emailField: ElementRef;

    @ViewChild('passwordField')
    private _passwordField: ElementRef;

    public user: IUserToRegister;
    public pending: boolean = false;
    public submitted: boolean = false;
    public msgs: any[] = [];

    private get next(): string {
        const next = this._route.snapshot.queryParams['n'];
        return next && decodeURIComponent(next) || '/kezdolap';
    }

    constructor(
        private _auth: Auth,
        private _router: Router,
        private _route: ActivatedRoute,
        private _messenger: MessengerService,
        private _breadcrumbs: BreadcrumbsService
    ) {
    }

    public ngOnInit(): void {
        this.user = {
            email: '',
            password: '',
            password_confirmation: '',
            lastname: '',
            firstname: '',
            nickname: '',
        };
        if (this._auth.isLoggedIn()) {
            this._router.navigate(['/']);
        }

        this._breadcrumbs.setTitle('Regisztráció');
    }

    ngAfterViewInit(): void {
        this._emailField.nativeElement.focus();
    }

    public closeAlert(alert: IAlert) {
        const index: number = this.msgs.indexOf(alert);
        this.msgs.splice(index, 1);
    }

    public doRegistration(regForm: NgForm): void {
        this.submitted = true;
        if (regForm.invalid) {
            this.msgs.push({
                severity: 'warning',
                summary: '',
                details: 'A becenév kivételével minden adatot kötelező megadni!'
            });
            return;
        }
        this.pending = true;
        this._auth.signUp(this.user).subscribe(
            () => this._router.navigateByUrl(this.next),
            this.onError.bind(this)
        );
    }

    private onError(error: any): void {
        this._messenger.handleError(error);
        this.pending = false;
        this.msgs[0] = {
            severity: 'danger',
            summary: 'Hiba!',
            details: this.getMessageFrom(error)
        };
        this._emailField.nativeElement.focus();
        this._emailField.nativeElement.select();
    }

    private getMessageFrom(error) {
        let message;
        if (error && error.json) {
            const eMessage = error.json();
            message = eMessage.message;
            if (eMessage.errors) {
                const messageParts = [];
                for (const key in eMessage.errors) {
                    if (eMessage.errors.hasOwnProperty(key)) {
                        messageParts.push(key + ': ' + eMessage.errors[key]);
                    }
                }
                message += ' Errors: ' + messageParts.join(', ');
            }
        } else {
            message = 'Ismeretlen hiba!';
        }
        return message;
    }

}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/auth/registration/registration.component.ts